import { ReactNode } from 'react';
import { AnalyticsTrackerWrapper } from './AnalyticsTrackerWrapper';

interface AppLayoutProps {
  children: ReactNode;
}

/**
 * Layout de base pour les pages publiques avec tracking analytics
 */
export const AppLayout = ({ children }: AppLayoutProps) => {
  return (
    <>
      <AnalyticsTrackerWrapper />
      {children}
    </>
  );
};
